import { getExperimentResultPromise } from '../../rockyExperimentCtrl';
import { VERIFICATION_JSON } from './resultHelper';

class SweepResultContentData {
  constructor() {
    this.resultJson = new Map();
  }

  saveResultExpData = (id, data) => {
    this.resultJson.set(id, data);
  }

  getResultExpLocalData = (id) => {
    return this.resultJson.get(id) || {};
  }

  // json
  getResultExpDataPromise = (expVerificationId, channelId, isNew) => {
    return new Promise((resolve, reject) => {
      const data = this.resultJson.get(channelId);
      if (!data || isNew) {
        getExperimentResultPromise({ verificationId: expVerificationId, option: VERIFICATION_JSON }).then(res => {
          this.saveResultExpData(channelId, res)
          this.saveResultExpData(expVerificationId, res)
          resolve(res);
        })
      } else {
        resolve(data)
      }
    })
  }

  getContent = (id) => {
    const info = this.getResultExpLocalData(id)
    return info.content || {};
  }

  getContentSimConfig = (id) => {
    const info = this.getResultExpLocalData(id)
    //  info.content.option.simConfig
    return info.content && info.content.option && info.content.option.simConfig ? info.content.option.simConfig : {};
  }


  getSignalGroupList = (id) => {
    const info = this.getResultExpLocalData(id)
    return info.ssn || [];
  }

  getSignalGroupFirstId = (id) => {
    const list = this.getSignalGroupList(id);
    return list[0] ? list[0].id : ''
  }

  getSignalGroupContent = (id, signalGroupId, name) => {
    const list = this.getSignalGroupList(id);
    const info = list.find(item => item.name === name || item.id === signalGroupId);
    return info || {};
  }

  clean = () => {
    this.resultJson = new Map();
  }
}


const sweepResultContentData = new SweepResultContentData();

export default sweepResultContentData